import { ADD_TAGS_TO_GMAIL_THREAD, CREATE_TAG, DELETE_TAG, GET_ALL_TAGS, REMOVE_TAGS_TO_GMAIL_THREAD } from "../constants";
import Requests from "../requests";

const TagService = {
    getAllTags,
    createTag,
    deleteTag,
    addTagsToGmailThread,
    removeTagsFromGmailThread,
    getColorForTag,
    loadTagsInCache
}

let cachedTags;

async function loadTagsInCache() {
    if (!cachedTags) {
        cachedTags = await getAllTags();
    }
}

async function deleteTag(tag_id) {
    return Requests.postWithAuth(DELETE_TAG, { tag_id });
}

async function getColorForTag(name) {

    if (cachedTags) {
        const tag = cachedTags.find(tag => tag.name === name);
        return tag ? tag.color : null;
    }
    // Fetch tags from the server if not cached

    const tags = await getAllTags();
    cachedTags = tags;
    // Check if the tag exists in the fetched tags
    const tag = tags.find(tag => tag.name === name);
    return tag ? tag.color : null;
}

async function addTagsToGmailThread({ thread_id, tags }) {
    return Requests.postWithAuth(ADD_TAGS_TO_GMAIL_THREAD, { thread_id, tags });
}

async function removeTagsFromGmailThread({ thread_id, tags }) {
    return Requests.postWithAuth(REMOVE_TAGS_TO_GMAIL_THREAD, { thread_id, tags });
}

async function getAllTags() {
    return Requests.getWithAuth(GET_ALL_TAGS);
}

async function createTag(tag) {
    return Requests.postWithAuth(CREATE_TAG, tag);
}

export default TagService;